import React, { ReactNode } from 'react';
import { Menu, Dropdown } from 'antd';
import './DropdownButton.less';

export type DropdownButtonProps = {
  actions?: any;
  icon?: ReactNode;
};

const TDropdownButton: React.FC<DropdownButtonProps> = ({
  actions,
  icon,
  children,
}) => {
  const menu = (
    <Menu className="t-dropdown-menu">
      {actions?.map((item, index) => {
        return <Menu.Item key={index}>{item}</Menu.Item>;
      })}
    </Menu>
  );
  const classNames = [!children && 't-dropdown-trigger-default'];
  return (
    <Dropdown.Button
      className={classNames.join(' ')}
      icon={icon}
      overlay={menu}
    >
      {children}
    </Dropdown.Button>
  );
};

export default TDropdownButton;
